import { Box, CircularProgress } from "@mui/material";

const LoadingWrapper = ({ my = 8 }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", my }}>
      <CircularProgress color="primary" size={80} thickness={5} />
    </Box>
  );
};

export default LoadingWrapper;
